module.exports = __webpack_public_path__ + "img/새로운혁신.0f6ba42e.png";